import { render, staticRenderFns } from "./AnimalProposalList.vue?vue&type=template&id=51b3219c&"
import script from "./AnimalProposalList.vue?vue&type=script&lang=js&"
export * from "./AnimalProposalList.vue?vue&type=script&lang=js&"
import style0 from "./AnimalProposalList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports